export default __webpack_public_path__ + "static/media/empty_icon.a236ddc6.svg";